module.exports = __webpack_public_path__ + "img/info3.0a33d134.jpg";